export const MenuItems = [
    {
        title: 'GitHub',
        url: 'https://github.com/utkarshtambe10',
        cName: 'nav-links'
    },
    {
        title: 'LinkedIn',
        url: 'https://linkedin.com/in/utkarshtambe-10',
        cName: 'nav-links'
    }
]
